// extracted by mini-css-extract-plugin
export var menu = "StickyMenu-module--menu--86f39";
export var menuContainer = "StickyMenu-module--menu-container--213e0";
export var menuFixed = "StickyMenu-module--menu-fixed--5f9f2";
export var menuFloating = "StickyMenu-module--menu-floating--95bc5";
export var menuSticky = "StickyMenu-module--menu-sticky--d57a9";
export var nav = "StickyMenu-module--nav--457d2";
export var navItem = "StickyMenu-module--nav-item--fde40";
export var navItemSelected = "StickyMenu-module--nav-item-selected--dbe25";
export var navWrapper = "StickyMenu-module--nav-wrapper--bb290";
export var spacer = "StickyMenu-module--spacer--16bbc";
export var summary = "StickyMenu-module--summary--1ca33";